import React, { Component } from 'react';
import { Segment, Header, Grid, Button, Icon } from 'semantic-ui-react';
import USAMap from "react-usa-map";

class LicStates extends Component {
  statesCustomConfig = () => {
    return {
      "CA": {
        fill: "#FFB805"
      },
      "NV": {
        fill: "#5AD0D2"
      },
      "AZ": {
        fill: "#E94A7E"
      }
    };
  };
  render() {
    return (
      <Segment style={{ padding: '4em 0em 8em 0em' }} vertical>
        <Grid stackable>
          <Grid.Row centered>
            <Header as='h3' style={{ fontSize: '2.5em', fontFamiy: 'Raleway', fontFamily: 'serif'}}> We are currently in these states... </Header>
          </Grid.Row>
          <Grid.Row centered>
            <USAMap styled={{padding: '2em 0em'}} customize={this.statesCustomConfig()} title='BeemaBroker is licensed in CA, AZ, and NV currently.'/>
          </Grid.Row>
          <Grid.Row centered>
              <Header as='h5' style={{ fontSize: '1.5em', fontFamiy: 'Montserrat'}}>
                Don't see your state? <br/>
                Share BeemaBroker with your founder friends to help unlock your state!
              </Header>
            </Grid.Row>
              <Grid.Row centered>
                <a className='twitter-share-button'
                  href="https://twitter.com/intent/tweet?text=BeemaBroker%20makes%20insurance%20so%20easy%3A&amp;hashtags=businessinsurance,startups,smallbusiness,beemabroker&amp;url=%68%74%74%70%73%3a%2f%2f%62%65%65%6d%61%62%72%6f%6b%65%72%2e%63%6f%6d%2f%68%6f%6d%65%23%72%65%71%75%65%73%74%2d%61%63%63%65%73%73">
                  <Button color='twitter'>
                    <Icon name='twitter' /> Tweet
                  </Button>
                </a>
                <a href='https://www.linkedin.com/shareArticle?mini=true&url=https://beemabroker.com'>
                  <Button color='linkedin'>
                    <Icon name='linkedin' /> Share
                  </Button>
                </a>
                <a className='fb-share-button' href='https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fbeemabroker.com'>
                  <Button color='facebook'>
                    <Icon name='facebook' /> Share
                  </Button>
                </a>
              </Grid.Row>
        </Grid>
      </Segment>
    );
  }
}

export default LicStates;



// WEBPACK FOOTER //
// ./src/js/Home/LicStates.js